<template>
  <div>
    <v-menu
      v-model="menuValue"
      transition="slide-y-transition"
      bottom
      left
      max-width="auto"
      offset-y
      class="mr-0"
    >
      <template v-slot:activator="{ on }">
        <div class="">
          <v-btn text v-on="on" block :class="{ active: menuValue }">
            <span v-if="lang == 'pt'">
              <img
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/br-flag.png"
                alt="flag"
                class="mt-1"
                width="20px"
              />
              <span class="pl-4 mb-2 overline">{{ $t("portuguese") }}</span>
            </span>
            <span v-if="lang == 'es'">
              <img
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/es-flag.png"
                alt="flag"
                class="mt-1"
                width="20px"
              />
              <span class="ml-4 mb-2 overline">{{ $t("spanish") }}</span>
            </span>
            <span v-if="lang == 'en'">
              <img
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/uk-flag.png"
                alt="flag"
                class="mt-1"
                width="20px"
              />
              <span class="ml-4 mb-2 overline">{{ $t("english") }}</span>
            </span>
            <v-icon right color="dark">mdi-menu-down</v-icon>
          </v-btn>
        </div>
      </template>
      <v-card>
        <v-list>
          <v-list-item @click="changeLang('pt')">
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/br-flag.png"
              />
            </v-list-item-action>

            <v-list-item-title class="overline"
              >{{ $t("portuguese") }}
            </v-list-item-title>
          </v-list-item>

          <v-list-item @click="changeLang('es')">
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/es-flag.png"
              />
            </v-list-item-action>

            <v-list-item-title class="overline">
              {{ $t("spanish") }}
            </v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLang('en')">
            <v-list-item-action>
              <img
                class="mr-2"
                width="24"
                src="https://sga-assets.s3.sa-east-1.amazonaws.com/flags/uk-flag.png"
              />
            </v-list-item-action>

            <v-list-item-title class="overline"
              >{{ $t("english") }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  data: () => ({
    lang: "",
    menuValue: null,
  }),
  mounted() {
    this.lang = localStorage.getItem("language");
  },
  methods: {
    changeLang(locale) {
      this.lang = locale;
      localStorage.setItem("language", locale);
      this.$axios.defaults.headers.language = locale;
      this.$router.go();
    },
  },
};
</script>

<style lang="scss" scoped>
.v-btn.active .v-icon {
  transform: rotate(180deg);
}
</style>
